import { memo } from 'react';

import { TranslateString } from '@/types/translation.types';
import { updateTranslateKey } from '@/utils/update-translation-key';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TEditCompanyProps = {
  company?: TranslateString | null;
  onChange: (value: TranslateString) => void;
  baseLanguage: string;
  language: string;
};

const EditCompany = memo(({ company, onChange, baseLanguage, language }: TEditCompanyProps) => {
  return (
    <label htmlFor="company" className="flex-1 flex-column gap-4 width-100-percent">
      <InputWithOverlay
        label="Company *"
        dirtyError={({ dirty, setHasError }) => {
          const hasError = dirty && !company?.base?.trim().length;
          setHasError(hasError);
        }}
        designSize="medium"
        inputProps={{
          id: 'company',
          value: company?.base || '',
          onChange: (e) => {
            onChange(
              updateTranslateKey({
                translateString: company ?? { base: '', changed: '' },
                input: e.target.value,
                baseLanguage,
                language,
              })
            );
          },
          placeholder: 'Add company',
        }}
      />
    </label>
  );
});

EditCompany.displayName = 'EditCompany';

export default EditCompany;
